var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configure"},[_c('div',{staticClass:"mains"},[_c('MySide'),_c('router-view')],1),_c('MyNav',{ref:"MyNav"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }